import { Alert, Snackbar } from '@all-manager/design-system-v2'
import { useStore } from '@tanstack/react-store'
import { removeSnackbar, snackbarStore } from './snackbarStore'

const AUTO_HIDE_DURATION_MS = 4000
const ANCHOR_ORIGIN = { vertical: 'top', horizontal: 'center' } as const

export function GlobalSnackbar() {
  const { snackbars } = useStore(snackbarStore)

  return (
    <>
      {snackbars.map((snackbar) => (
        <Snackbar
          key={snackbar.id}
          open
          autoHideDuration={AUTO_HIDE_DURATION_MS}
          onClose={() => removeSnackbar(snackbar.id)}
          anchorOrigin={ANCHOR_ORIGIN}
        >
          <Alert
            severity={snackbar.severity}
            variant="filled"
            onClose={() => removeSnackbar(snackbar.id)}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  )
}
